import { render, staticRenderFns } from "./UserDetailPremiumComment.vue?vue&type=template&id=2f195247&scoped=true&"
import script from "./UserDetailPremiumComment.vue?vue&type=script&lang=js&"
export * from "./UserDetailPremiumComment.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailPremiumComment.vue?vue&type=style&index=0&id=2f195247&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f195247",
  null
  
)

export default component.exports